<template>
  <section class="content">
    <div v-if="!$gate.isType('admin') || ['admin', 'editor'].includes(user.type)">
      <not-found></not-found>
    </div>
    <div v-else class="container-fluid">
      <loader v-if="loading" :type="'table'"/>
      <div v-else>
        <div class="row">
          <div class="col-12">
            <h1>User Subscription</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 v-if="user.name" class="card-title">{{user.name}}</h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                  <div v-if="user.main_subscription">
                    <p class="h2">
                      <strong>Status:</strong> 
                      <span class="text-danger" v-if="user.main_subscription.canceled_at">Cancelled</span>
                      <span class="text-warning" v-else-if="!user.main_subscription.is_active">Ended</span>
                      <span class="text-success" v-else>Active</span>
                    </p>
                    <span v-if="user.main_subscription.canceled_at"><strong>Canceled at:</strong> {{user.main_subscription.canceled_at | localDate}}<br></span> 
                    <strong>Plan:</strong> {{user.main_subscription.plan_id | plan_id}} <br>
                    <strong>Ends at:</strong> {{user.main_subscription.ends_at | localDate}} <br>
                    <hr>
                  </div>
                  <p v-else>-No subscription-</p>
                  <div v-if="!user.main_subscription || (user.main_subscription && !user.main_subscription.canceled_at)">
                    <h3>{{user.main_subscription ? 'Change' : 'Add'}} Subscription</h3>
                    <div class="form-group">
                      <select name="plan" id="plan" class="form-select">
                          <option value="">- Select Plan -</option>
                          <option :selected="user.main_subscription && user.main_subscription.plan_id == 1" value="1">Basic</option>
                          <option :selected="user.main_subscription && user.main_subscription.plan_id == 2" value="2">Professional</option>
                          <option :selected="user.main_subscription && user.main_subscription.plan_id == 3" value="3">Plus</option>
                          <option :selected="user.main_subscription && user.main_subscription.plan_id == 4" value="4">Agreement</option>
                      </select>
                    </div>
                    <button v-if="!user.main_subscription" class="btn btn-primary" @click="addSubscription">Set Subscription</button>
                    <button v-if="user.main_subscription && !user.main_subscription.canceled_at" class="btn btn-primary" @click="changeSubscription">Change Subscription</button>
                    <hr>
                  </div>
                  <div v-if="user.main_subscription && user.main_subscription.is_active">
                    <h3>Extra features</h3>
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="extra_features" value="mx_chamber" id="mx-chamber-extra-feature-check" v-model="extra_features.mx_chamber">
                        <label class="form-check-label" for="mx-chamber-extra-feature-check">
                          mxChamber Search
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="extra_features" value="wa_messager" id="wa-messager-extra-feature-check" v-model="extra_features.wa_messager">
                        <label class="form-check-label" for="wa-messager-extra-feature-check">
                          WhatsApp Messager
                        </label>
                      </div>
                    </div>
                    <button class="btn btn-primary" @click="updateExtraFeatures">Update extra features</button>
                    <hr>
                  </div>
                  <div v-if="user.main_subscription && !user.main_subscription.canceled_at">
                    <h3>Renew subscription</h3>
                    <button class="btn btn-primary" @click="renewSubscription">Renew Subscription</button>
                    <hr>
                  </div>
                  <div v-if="user.main_subscription && !user.main_subscription.canceled_at">
                    <h3>Cancel subscription</h3>
                    <div class="form-group">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="cancel_immediately" name="cancel_immediately">
                        <label class="form-check-label" for="cancel_immediately">Cancel immediately</label>
                      </div>
                    </div>
                    <button class="btn btn-danger" @click="cancelSubscription">Cancel Subscription</button>
                  </div>
                  <div v-if="user.main_subscription && user.main_subscription.canceled_at">
                    <button class="btn btn-success" @click="activateSubscription">Activate Subscription</button>
                  </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
        user: {},
        loading : true,
        extra_features: {
          mx_chamber : false,
          wa_messager : false
        }
    };
  },
  methods: {
    loadUserSubscription(){
      axios.get("/api/user/"+this.$route.params.user_id).then(({ data }) => {
        var user = data.data;
        this.user = user;
        this.loading = false;
        this.extra_features.mx_chamber = this.$gate.hasFeaturePermission('mx_chamber', user);
        this.extra_features.wa_messager = this.$gate.hasFeaturePermission('wa_messager', user);
      });
    },
    addSubscription(){
      this.$Progress.start();
      let plan_id = $('select#plan').val();
      axios.post("/api/user/addSubscription/"+this.$route.params.user_id, {plan_id:plan_id}).then(({ data }) => {
        Toast.fire({
          icon: 'success',
          title: data.message
        });
        this.$Progress.finish();
        this.loadUserSubscription();
      }).catch((error)=>{
        let error_obj = JSON.parse(error.request.response);
        let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
        Toast.fire({
            icon: 'error',
            title: error_title
        });
        this.$Progress.fail();
      });
    },
    changeSubscription(){
      this.$Progress.start();
      let plan_id = $('select#plan').val();
      axios.post("/api/user/changeSubscription/"+this.$route.params.user_id, {plan_id:plan_id}).then(({ data }) => {
        Toast.fire({
          icon: 'success',
          title: data.message
        });
        this.$Progress.finish();
        this.loadUserSubscription();
      }).catch((error)=>{
        let error_obj = JSON.parse(error.request.response);
        let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
        Toast.fire({
            icon: 'error',
            title: error_title
        });
        this.$Progress.fail();
      });
    },
    cancelSubscription(){
      let cancel_immediately = $("#cancel_immediately").is(':checked');
      Swal.fire({
        title: 'Are you sure?',
        text: 'This will cancel the user subscription',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonText: 'Go back',
        confirmButtonText: 'Yes, Cancel it!'
      }).then((result) => {
        if (result.value) {
          this.$Progress.start();
          axios.post("/api/user/cancelSubscription/"+this.$route.params.user_id, {cancel_immediately:cancel_immediately}).then(({ data }) => {
            Toast.fire({
              icon: 'success',
              title: data.message
            });
            this.$Progress.finish();
            this.loadUserSubscription();
          }).catch((error)=>{
            let error_obj = JSON.parse(error.request.response);
            let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
            Toast.fire({
                icon: 'error',
                title: error_title
            });
            this.$Progress.fail();
          });
        }
      });
    },
    activateSubscription(){
      this.$Progress.start();
      axios.get("/api/user/activate_subscription/"+this.$route.params.user_id).then(({ data }) => {
        Toast.fire({
          icon: 'success',
          title: data.message
        });
        this.$Progress.finish();
        this.loadUserSubscription();
      }).catch((error)=>{
        let error_obj = JSON.parse(error.request.response);
        let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
        Toast.fire({
            icon: 'error',
            title: error_title
        });
        this.$Progress.fail();
      });
    },
    renewSubscription(){
      this.$Progress.start();
      axios.get("/api/user/renewSubscription/"+this.$route.params.user_id).then(({ data }) => {
        Toast.fire({
          icon: 'success',
          title: data.message
        });
        this.$Progress.finish();
        this.loadUserSubscription();
      }).catch((error)=>{
        let error_obj = JSON.parse(error.request.response);
        let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
        Toast.fire({
            icon: 'error',
            title: error_title
        });
        this.$Progress.fail();
      });
    },
    updateExtraFeatures(){
      this.$Progress.start();
      axios.post("/api/user/extraFeatures/"+this.$route.params.user_id, {features: JSON.stringify(this.extra_features)}).then(({ data }) => {
        Toast.fire({
          icon: 'success',
          title: data.message
        });
        this.$Progress.finish();
        this.loadUserSubscription();
      }).catch((error)=>{
        let error_obj = JSON.parse(error.request.response);
        let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
        Toast.fire({
          icon: 'error',
            title: error_title
        });
        this.loadUserSubscription();
        this.$Progress.fail();
      });
    }
  },
  mounted() {
    this.loadUserSubscription();
  },
  created() {},
  filters: {
        plan_id: function (value) {
            switch(value){
                case 1:
                    return 'Basic';
                case 2:
                    return 'Professional';
                case 3:
                    return 'Plus';
                case 4:
                    return 'Agreement';
                default:
                    return ''
            }
        }
    }
};
</script>
